import React from 'react';

function Spacer({margin, padding}) {
  return (
      <div style={{margin: margin ?? '15px',padding: padding ?? '0px'}}></div>
  );
}

export default Spacer;